<script>
    import { onMount } from "svelte";
    import { loggedInDoctorDetail, user } from "../../stores";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";
    import DailyPlanner from "../../Pages/Calendar/DailyPlanner.svelte";
    import VerticalCalendar from "../../Pages/Calendar/CalendarType/VerticalCalendar.svelte";

    export let params;
    export let tokenRefresh = undefined;

    let isVView = false;

    onMount(async () => {
        isVView = $user.settings?.dailyPlannerVerticalView;
        tokenRefresh = checkTokenExpiration();
    });
</script>

{#await tokenRefresh then tokenRefreshResult}
    {#if tokenRefreshResult === "valid" || tokenRefreshResult === "refreshed"}
        <div class="flex flex-1 flex-col w-full px-6 py-4 bg-gray-200">
            {#if isVView}
                <VerticalCalendar
                    {params}
                    on:defaultView={() => (isVView = false)}
                    url={$user.role == 2 ? "/DailyPlanner/" : "/DailyPlanner"}
                    accountId={$user.role == 2 ? $loggedInDoctorDetail.id : Number(0)}
                    isCalendarRoute
                />
            {:else}
                <DailyPlanner
                    {params}
                    on:verticalView={() => (isVView = true)}
                    url={$user.role == 2 ? "/DailyPlanner/" : "/DailyPlanner"}
                    accountId={$user.role == 2 ? $loggedInDoctorDetail.id : Number(0)}
                />
            {/if}
        </div>
    {/if}
{/await}
